import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import queryString from 'query-string';

import * as AccountActions from "../data/accounts/AccountActions";
import * as IntegrationsActions from "../data/integrations/IntegrationsActions";
import * as MediaActions from "../data/media/MediaActions";
import * as PostActions from "../data/posts/PostActions";
import * as StoryActions from "../data/stories/StoryActions";
import * as ProjectActions from "../data/projects/ProjectActions";
import * as UserActions from "../data/users/UserActions";
import * as SlideActions from "../data/slides/SlideActions";

import StoryRoute from './StoryRoute';

import MediaController from '../controllers/MediaController';
import SharingController from '../controllers/SharingController';
import ProjectsController from '../controllers/ProjectsController';
import StoryListController from '../controllers/StoryListController';
import IntegrationsController from '../controllers/IntegrationsController';
import UserController from "Controllers/UserController";
import SettingsController from "Controllers/SettingsController";
import Sidenav from "Components/Sidenav";
import ProjectController from "Controllers/ProjectController";
import ProjectRoute from "./ProjectRoute";

class AppRoute extends React.Component
{
    state = {
        loading: true
    };

    static propTypes = {
        slug: PropTypes.string,
        accountId: PropTypes.string,
        fetchAccountList: PropTypes.func.isRequired,
    };

    componentDidMount()
    {
        this.props.fetchAccountList().then(accounts => {
            const account = _.find(accounts, account => account.slug === this.props.slug);

            if (! account) {
                // Erm, slug doesn't match accounts for the user...
                this.props.history.push('/accounts');
                return;
            }

            Promise.all([
                this.props.selectAccount(account.id),
                this.props.listIntegrations(account.id),
                this.props.fetchMediaList(account.id),
                this.props.listPosts(account.id),
                this.props.fetchStoryList(account.id).then(stories => {

                    // looking to async this bit..
                    setTimeout(() => {
                        stories.map(story => this.props.fetchSlides(story.id));
                    }, 1);

                    return stories;
                }),
                this.props.listProjects(account.id),
                this.props.fetchInvites(),
                this.props.fetchTeamMembers()
            ]).then(() => {
                this.setState({loading: false});
            });

        });
    }

    render()
    {
        if (! this.props.accountId) {
            return null;
        }

        return <div className="h-full flex overflow-hidden bg-gray-100">
            { this.renderSidenav() }
            { this.renderPage() }
        </div>;
    }

    // The switch ensures only one of the children is rendered.
    // If the path is matched, it will render... nothing.
    // Otherwise, if the path is NOT matched, the sidebar renders.
    renderSidenav()
    {
        return <Switch>
            <Route exact path="/stories/:storyId/edit" />
            <Route path="/projects/:projectId" />
            <Sidenav />
        </Switch>;
    }

    renderPage()
    {
        const query = queryString.parse(this.props.location.search);

        return <Switch key={this.props.location.key}>
            <Route path="/stories/:storyId">
                { props => <StoryRoute {...props} loading={this.state.loading} /> }
            </Route>

            <Route path="/projects/:projectId">
                { props => <ProjectRoute {...props} loading={this.state.loading} /> }
            </Route>

            <Route exact path="/stories">
                <StoryListController loading={this.state.loading} />
            </Route>

            <Route exact path="/media">
                <MediaController loading={this.state.loading} />
            </Route>

            <Route exact path="/sharing">
                <SharingController loading={this.state.loading} status={query.status} />
            </Route>

            <Route exact path="/projects">
                <ProjectsController loading={this.state.loading} />
            </Route>

            <Route exact path="/integrations">
                <IntegrationsController loading={this.state.loading} />
            </Route>

            <Route exact path="/settings">
                <SettingsController loading={this.state.loading} />
            </Route>

            <Route exact path="/user">
                <UserController loading={this.state.loading} />
            </Route>

            <Redirect to="/stories" />
        </Switch>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    loggedIn: !! state.auth.id,
    accountId: state.currentAccountId,
    slug: window.location.hostname.split(".")[0],
});

const mapDispatchToProps = {
    selectAccount: AccountActions.selectAccount,
    fetchAccountList: AccountActions.fetchAccountList,
    listIntegrations: IntegrationsActions.listIntegrations,
    fetchMediaList: MediaActions.fetchMediaList,
    listPosts: PostActions.listPosts,
    fetchStoryList: StoryActions.fetchStoryList,
    listProjects: ProjectActions.listProjects,
    fetchInvites: UserActions.fetchInvites,
    fetchTeamMembers: UserActions.fetchTeamMembers,
    fetchSlides: SlideActions.listSlides
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AppRoute)
);